import { render, staticRenderFns } from "./MasterTaxAttorneyFees.vue?vue&type=template&id=74924c41&scoped=true&"
import script from "./MasterTaxAttorneyFees.vue?vue&type=script&lang=js&"
export * from "./MasterTaxAttorneyFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74924c41",
  null
  
)

export default component.exports